import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=3eda9d10&scoped=true"
import script from "./Competitions.vue?vue&type=script&lang=js"
export * from "./Competitions.vue?vue&type=script&lang=js"
import style0 from "./Competitions.vue?vue&type=style&index=0&id=3eda9d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eda9d10",
  null
  
)

export default component.exports